import { render, staticRenderFns } from "./RowExpandable.vue?vue&type=template&id=3c1d9641&scoped=true&"
import script from "./RowExpandable.vue?vue&type=script&lang=js&"
export * from "./RowExpandable.vue?vue&type=script&lang=js&"
import style0 from "./RowExpandable.vue?vue&type=style&index=0&id=3c1d9641&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1d9641",
  null
  
)

export default component.exports